<script setup lang="ts">
import {computed, type ComputedRef, type PropType} from 'vue';
import {StatisticTypeEnum} from '@/constants/enums.ts';
import {useI18n} from 'vue-i18n';
import {useDashboardStore} from '@/store';

const props = defineProps({
  statType: {
    type: String as PropType<StatisticTypeEnum>,
    required: true
  }
});

const dashboardStore = useDashboardStore(),
  {t} = useI18n();

const statPerCompl: ComputedRef<string> = computed(() => {
  const stats = dashboardStore.statisticSummaries['Wearable'],
    result = stats?.details.find((s) => s.dataTypeKey === props.statType && s.periodType === 'All-Days')?.dataValue
  
  return `${result ? Math.round(result * 100) : 0}%`;
});

const statTtl: ComputedRef<string> = computed(() => {
  switch (props.statType) {
    case StatisticTypeEnum.EducationProgress:
      return t('gen_education');
    case StatisticTypeEnum.ExerciseProgress:
      return t('gen_exercises_ios');
    case StatisticTypeEnum.SurveyProgress:
      return t('gen_surveys');
    default:
      return '';
  }
});
</script>

<template>
  <h6>{{ statTtl }}</h6>
  <div class="row no-wrap items-center">
    
    <!-- Progress Bar -->
    <div class="col prog-bar">
      <div class="track">
        <div class="bar"
             :style="`width: ${statPerCompl};`" />
      </div>
    </div>
    
    <!-- Completion Percentage -->
    <div class="col-auto completion-per">{{ statPerCompl }}</div>
  </div>
</template>

<style scoped lang="scss">
@use 'sass:map';
@use 'sass:math';

.row {
  column-gap: 8px;

  &:not(:last-child) { // .row
    margin-block-end: 20px;
  }
  
  // Progress Bar
  .prog-bar { // .col
  
    div {
      $completion-bar-ht: 5px;
  
      height: $completion-bar-ht;
      border-radius: math.div($completion-bar-ht, 2);
    }
  
    .track {
      background-color: $content-assets-dta-viz-empty;
    }
  
    .bar {
      background: linear-gradient(115deg, map.get($co-brand-clrs, cnt-branded-grd-1) 22%, map.get($co-brand-clrs, cnt-branded-grd-2) 79%);
    }
  }
  
  // Completion Percentage
  .completion-per { // .col-auto
    min-width: 40px;
    width: 40px;
    font-size: map.get($font-sizes, '14');
    line-height: 18px;
    color: $content-type-sec;
    text-align: right;
  }
}
</style>